import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
import s from './ToolTip.css';
import { connect } from 'react-redux';
import { hideToolTip } from '../../actions/toolTip';
import { isEmptyString } from '../../core/util/string';
import { analyticsTrackEvent } from '../../core/analytics';
import { hideToolTipCookie } from './index';

const mapStateToProps = state => ({
  toolTip: state.toolTip,
  showArrow: state.showArrow,
});

const mapDispatchToProps = dispatch => ({
  markToolTipClosed: name => {
    dispatch(hideToolTip(name));
    hideToolTipCookie(name);
  },
});

const toolTipTimeouts = {};

const ToolTip = props => {
  const isVisible = () => {
    try {
      return props.toolTip[props.name].visible !== false;
    } catch (e) {
      // tooltips default to visible
      return true;
    }
  };

  const handleOnClick = () => {
    if (!props.closeable) {
      return;
    }

    props.markToolTipClosed(props.name);
    if (props.closeEvent) {
      analyticsTrackEvent(props.closeEvent);
    }
  };

  const handleCloseAll = () => {
    if (!props.closeable) {
      return;
    }

    handleOnClick();

    for (const toolTipName of props.linkedToolTips) {
      props.markToolTipClosed(toolTipName);
    }
  };

  const handleOnTimeOut = () => props.markToolTipClosed(props.name);

  if (
    typeof props.hideAfter !== 'undefined' &&
    props.hideAfter > 0 &&
    !toolTipTimeouts.hasOwnProperty(props.name) &&
    isVisible()
  ) {
    toolTipTimeouts[props.name] = setTimeout(handleOnTimeOut, props.hideAfter * 1000);
  }

  const getPositionClass = () => {
    if (isEmptyString(props.position)) {
      return s.center;
    }

    return s[props.position];
  };

  if (isVisible() && props.showEvent) {
    analyticsTrackEvent(props.showEvent);
  }

  if (!isVisible()) {
    return <div />;
  }

  const getToolTipClassName = () => {
    switch (props.theme) {
      case 'blue':
        return s.toolTipBlue;
      case 'dark':
      default:
        return s.toolTip;
    }
  };

  return (
    <div className={getPositionClass()}>
      <div className={props.containerClass}>
        {props.showUnderlay && <div className={s.underlay} onClick={handleCloseAll} />}
        <div className={isVisible() ? s.toolTipContainer : s.toolTipHidden}>
          <div className={getToolTipClassName()}>
            <div
              className={props.closeable ? s.contentCloseable : s.content}
              onClick={handleOnClick}
            >
              {props.children}
            </div>
          </div>
          {props.showArrow && <div className={s.arrow} />}
        </div>
      </div>
    </div>
  );
};

ToolTip.propTypes = {
  name: PropTypes.string.isRequired,
  markToolTipClosed: PropTypes.func,
  hideAfter: PropTypes.number,
  position: PropTypes.string,
  showEvent: PropTypes.string,
  closeEvent: PropTypes.string,
  closeable: PropTypes.bool,
  linkedToolTips: PropTypes.array,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]).isRequired,
  containerClass: PropTypes.string,
  onClickToHide: PropTypes.func,
  showArrow: PropTypes.bool,
  showUnderlay: PropTypes.bool,
  theme: PropTypes.string,
  toolTip: PropTypes.object,
};

ToolTip.defaultProps = {
  closeable: true,
  linkedToolTips: [],
  showUnderlay: true,
  theme: 'dark',
};

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ToolTip)
);
